export class DateTimeUtils {

    // ms => 00:05:00.0
    public static msToTime(milliseconds: string | number, removeLeadingZeros = false) {
        const duration = Number(milliseconds);

        const millis = parseInt(`${(duration % 1000) / 100}`, 10);
        const seconds = Math.floor((duration / 1000) % 60);
        const minutes = Math.floor((duration / (1000 * 60)) % 60);
        const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
        const days = Math.floor((duration / (1000 * 60 * 60 * 24)));

        const daysStr = (days < 10) ? '0' + days : days;
        const hoursStr = (hours < 10) ? '0' + hours : hours;
        const minutesStr = (minutes < 10) ? '0' + minutes : minutes;
        const secondsStr = (seconds < 10) ? '0' + seconds : seconds;

        const time = daysStr + ':' + hoursStr + ':' + minutesStr + ':' + secondsStr + '.' + millis;
        if (removeLeadingZeros) {
            return time.replace(/^(00:)+/i, "00:");
        }

        return time
    }

    // s => 00:05:00.0
    public static secondsToTime(_seconds: string | number, removeLeadingZeros = false) {
        const duration = Number(_seconds) * 1000;
        return DateTimeUtils.msToTime(duration, removeLeadingZeros);
    }
}
